import api from './axios';

export function isAiReviewConfigured() {
  return true;
}

export async function checkReaderComprehension({ title, summary }) {
  try {
    const res = await api.post('/admin/ai/reader-check', { title, summary });
    if (res.data && res.data.success) {
      return res.data.data;
    }
    throw new Error(res.data?.message || 'Reader check failed');
  } catch (err) {
    const message = err.response?.data?.message || err.message || 'Reader check failed';
    throw new Error(message);
  }
}

export async function reviewArticleWithAI({ title, summary }) {
  try {
    const res = await api.post('/admin/ai/review', { title, summary });
    if (res.data && res.data.success) {
      return res.data.data;
    }
    throw new Error(res.data?.message || 'AI review failed');
  } catch (err) {
    const message = err.response?.data?.message || err.message || 'AI review failed';
    throw new Error(message);
  }
}
